// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"7d04bced","410":"79aa92fe","787":"307af628","819":"895f8f89"}[chunkId] + ".chunk.js";
};